module.exports = __webpack_public_path__ + "static/img/banner-01.1bcd192e.jpg";